<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_status === true">เปลี่ยนสถานะเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มเรทราคาเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขเรทราคาเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_delete === true">ลบเรทราคาเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2 d-flex align-center justify-space-between">
            <h2>จัดการเรทค่าส่งพัสดุ</h2>
            <div>
                <v-btn color="#28ab28" class="white--text" @click="openRateAdd()" width="100%" height="65">
                    เพิ่มเรทราคา
                </v-btn>
            </div>
        </div>
        <v-card>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data" :search="search">
                <template v-slot:item="dataDetail">
                    <tr>
                        <td>{{dataDetail.item.qty}}</td>
                        <td>{{dataDetail.item.price}}</td>
                        <td>
                            <span>
                                <v-switch color="success" v-model="dataDetail.item.status" @click="changeStatus(dataDetail.item.id)"></v-switch>
                            </span>
                        </td>
                        <td>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" width="50">mdi-dots-vertical</v-icon>
                                </template>
                                <v-list>
                                    <v-list-item class="cursor_content_delivery_rate_list" @click="deliveryRateDetail(dataDetail.item.id)">
                                        <v-list-item-title>แก้ไขเรทราคา</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item class="cursor_content_delivery_rate_list" @click="confirmDeleteDeliveryRate(dataDetail.item.id)">
                                        <v-list-item-title>ลบเรทราคา</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <!-- เพิ่ม -->
        <v-dialog v-model="open_rate_add" persistent max-width="600px">
            <v-card>
                <v-form ref="form_add" @submit.prevent="addDeliveryRate()">
                    <v-card-title class="justify-space-between">
                        <div>
                            เพิ่มเรทราคา
                        </div>
                        <div class="cursor_content_delivery_rate_list" @click="open_rate_add = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-radio-group class="mt-0" v-model="type" hide-details="auto">
                                        <div class="d-flex">
                                            <div class="d-flex">
                                                <v-radio color="primary" value="0"></v-radio>
                                                <div class="mr-1">กำหนดเอง</div>
                                            </div>
                                            <div class="d-flex">
                                                <v-radio color="primary" value="1"></v-radio>
                                                <div class="mr-1">น้อยกว่า</div>
                                            </div>
                                            <div class="d-flex">
                                                <v-radio color="primary" value="2"></v-radio>
                                                <div class="mr-1">มากกว่า</div>
                                            </div>
                                        </div>
                                    </v-radio-group>
                                    <div class="grid_content_delivery_rate_list" v-if="type == 0">
                                        <v-text-field label="จำนวนเริ่มต้น" type="number" class="mr-1" v-model="first_qty" :rules="[v => !!v || 'กรุณากรอกจำนวนเริ่มต้น']" required outlined></v-text-field>
                                        <v-text-field label="จำนวนสิ้นสุด" type="number" class="ml-1" v-model="end_qty" :rules="[v => !!v || 'กรุณากรอกจำนวนสิ้นสุด']" required outlined></v-text-field>
                                    </div>
                                    <div v-if="type != 0">
                                        <v-text-field label="จำนวน" type="number" v-model="qty" :rules="[v => !!v || 'กรุณากรอกจำนวนเริ่มต้น']" required outlined></v-text-field>
                                    </div>
                                    <v-text-field label="ราคา" type="number" v-model="price" :rules="[v => !!v || 'กรุณากรอกราคา']" required outlined></v-text-field>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                            บันทึก
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- แก้ไข -->
        <v-dialog v-model="open_rate_edit" persistent max-width="600px">
            <div v-if="loading_detail_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_detail_page === false">
                <v-form ref="form_edit" @submit.prevent="editDeliveryRate()">
                    <v-card-title class="justify-space-between">
                        <div>
                            แก้ไขเรทราคา
                        </div>
                        <div class="cursor_content_delivery_rate_list" @click="open_rate_edit = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-radio-group class="mt-0" v-model="type" hide-details="auto">
                                        <div class="d-flex">
                                            <div class="d-flex">
                                                <v-radio color="primary" value="0"></v-radio>
                                                <div class="mr-1">กำหนดเอง</div>
                                            </div>
                                            <div class="d-flex">
                                                <v-radio color="primary" value="1"></v-radio>
                                                <div class="mr-1">น้อยกว่า</div>
                                            </div>
                                            <div class="d-flex">
                                                <v-radio color="primary" value="2"></v-radio>
                                                <div class="mr-1">มากกว่า</div>
                                            </div>
                                        </div>
                                    </v-radio-group>
                                    <div class="grid_content_delivery_rate_list" v-if="type == 0">
                                        <v-text-field label="จำนวนเริ่มต้น" type="number" class="mr-1" v-model="first_qty" :rules="[v => !!v || 'กรุณากรอกจำนวนเริ่มต้น']" required outlined></v-text-field>
                                        <v-text-field label="จำนวนสิ้นสุด" type="number" class="ml-1" v-model="end_qty" :rules="[v => !!v || 'กรุณากรอกจำนวนสิ้นสุด']" required outlined></v-text-field>
                                    </div>
                                    <div v-if="type != 0">
                                        <v-text-field label="จำนวน" type="number" v-model="qty" :rules="[v => !!v || 'กรุณากรอกจำนวนเริ่มต้น']" required outlined></v-text-field>
                                    </div>
                                    <v-text-field label="ราคา" type="number" v-model="price" :rules="[v => !!v || 'กรุณากรอกราคา']" required outlined></v-text-field>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                            บันทึก
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- ลบ -->
        <v-dialog v-model="open_rate_delete" persistent max-width="600">
            <v-card>
                <v-card-title>
                    ลบเรทราคา
                </v-card-title>

                <v-card-text>
                    ท่านต้องการลบเรทราคานี้ ใช่ หรือ ไม่ ?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" height="50" @click="deleteDeliveryRate()">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" height="50" @click="cancelDeleteDeliveryRate()">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import contentdeliveryrate from '@/api/content/contentsetting/contentdeliveryrate.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_detail_page: true,
            alert_show_status: false,
            alert_show_add: false,
            alert_show_edit: false,
            alert_show_delete: false,
            open_rate_add: false,
            open_rate_edit: false,
            open_rate_delete: false,
            edit_id: null,
            type: '0',
            first_qty: null,
            end_qty: null,
            qty: null,
            price: null,
            search: '',
            headers: [{
                    text: 'จำนวน',
                    value: 'qty',
                },
                {
                    text: 'ราคา',
                    value: 'price'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
        }
    },
    methods: {
        async deliveryRateList() {
            this.loading_page = true
            this.data = []
            contentdeliveryrate.deliveryRateList().then((response) => {
                if (response.data.successful === true) {
                    response.data.list.forEach((detail) => {
                        if (detail.type == 0) {
                            this.data.push({
                                id: detail.id,
                                qty: detail.first_qty + '-' + detail.end_qty,
                                price: detail.price,
                                status: detail.status,
                            })
                        }
                        if (detail.type != 0) {
                            if (detail.type == 1) {
                                this.data.push({
                                    id: detail.id,
                                    qty: `น้อยกว่า ${detail.qty}`,
                                    price: detail.price,
                                    status: detail.status,
                                })
                            }
                            if (detail.type == 2) {
                                this.data.push({
                                    id: detail.id,
                                    qty: `มากกว่า ${detail.qty}`,
                                    price: detail.price,
                                    status: detail.status,
                                })
                            }
                        }
                    })
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async changeStatus(id) {
            contentdeliveryrate.changeStatusDeliveryRate(id).then((response) => {
                if (response.data.successful === true) {
                    this.alert_show_status = true
                    setTimeout(() => this.alert_show_status = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async openRateAdd() {
            this.open_rate_add = true
            this.type = '0'
            this.first_qty = null
            this.end_qty = null
            this.qty = null
            this.price = null
        },
        async addDeliveryRate() {
            if (this.$refs.form_add.validate()) {
                this.open_rate_add = false
                this.loading_page = true
                const data = {
                    type: this.type,
                    price: this.price,
                }
                if (this.type == 0) {
                    data.first_qty = this.first_qty
                    data.end_qty = this.end_qty
                }
                if (this.type != 0) {
                    data.qty = this.qty
                }
                contentdeliveryrate.addDeliveryRate(data).then((response) => {
                    if (response.data.successful === true) {
                        this.type = '0'
                        this.first_qty = null
                        this.end_qty = null
                        this.qty = null
                        this.price = null
                        this.deliveryRateList()
                        this.alert_show_add = true
                        setTimeout(() => this.alert_show_add = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async deliveryRateDetail(id) {
            this.open_rate_edit = true
            this.loading_detail_page = true
            contentdeliveryrate.deliveryRateDetail(id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = response.data.detail.id
                    this.type = response.data.detail.type.toString()
                    this.first_qty = response.data.detail.first_qty
                    this.end_qty = response.data.detail.end_qty
                    this.qty = response.data.detail.qty
                    this.price = response.data.detail.price
                    this.loading_detail_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async editDeliveryRate() {
            if (this.$refs.form_edit.validate()) {
                this.open_rate_edit = false
                this.loading_page = true
                const data = {
                    type: this.type,
                    price: this.price,
                }
                if (this.type == 0) {
                    data.first_qty = this.first_qty
                    data.end_qty = this.end_qty
                    data.qty = null
                }
                if (this.type != 0) {
                    data.first_qty = null
                    data.end_qty = null
                    data.qty = this.qty
                }
                contentdeliveryrate.editDeliveryRate(this.edit_id, data).then((response) => {
                    if (response.data.successful === true) {
                        this.edit_id = null
                        this.type = '0'
                        this.first_qty = null
                        this.end_qty = null
                        this.qty = null
                        this.price = null
                        this.deliveryRateList()
                        this.alert_show_edit = true
                        setTimeout(() => this.alert_show_edit = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async confirmDeleteDeliveryRate(id) {
            this.open_rate_delete = true
            this.edit_id = id
        },
        async cancelDeleteDeliveryRate() {
            this.open_rate_delete = false
            this.edit_id = null
        },
        async deleteDeliveryRate() {
            this.open_rate_delete = false
            this.loading_page = true
            contentdeliveryrate.deleteDeliveryRate(this.edit_id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = null
                    this.type = '0'
                    this.first_qty = null
                    this.end_qty = null
                    this.qty = null
                    this.price = null
                    this.deliveryRateList()
                    this.alert_show_delete = true
                    setTimeout(() => this.alert_show_delete = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        }
    },
    mounted() {
        this.deliveryRateList()
    }
}
</script>

<style scoped>
.cursor_content_delivery_rate_list {
    cursor: pointer;
}

.grid_content_delivery_rate_list {
    display: grid;
    grid-template-columns: 50% 50%;
}
</style>
